import React, { memo } from "react";
import { NavLink } from 'react-router';
import { Box, Typography } from '@mui/material';

import { ICategoryCard } from "../../../types/chat";

type CategoryCardProps = {
    category: ICategoryCard;
};

const CategoryCard: React.FC<CategoryCardProps> = ({
    category
}) => {
    const { icon, title, description, id } = category;

    return (
        <NavLink style={{ cursor: 'pointer', textDecoration: 'none' }} to={`/${id}`}>
            <Box
                sx={{
                    padding: { xs: '12px', sm: '12px', md: '12px', lg: '16px', xl: '20px' },
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    bgcolor: 'background.paper',
                    width: { xs: '14rem', sm: '14rem', md: '15rem', lg: '15rem', xl: '16.4rem' },
                    borderRadius: '1rem',
                    boxShadow: '0px 1px 2px -1px #0000001A, 0px 1px 3px 0px #0000001A',
                    transition: 'box-shadow 0.2s ease-in-out',
                    '&:hover': {
                        boxShadow: '0 4px 8px rgba(47,59,70,0.1)',
                    },
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        width: { xs: 48, lg: 56 },
                        height: { xs: 48, lg: 56 },
                        justifyContent: 'center',
                        alignItems: 'center',
                        bgcolor: 'grey.50',
                        color: 'custom.brandTeal',
                        borderRadius: '12px',
                        border: '1px solid #EBEFF580',
                    }}
                >
                    {typeof icon === 'string' ? <img src={icon} alt={title} style={{ width: '100%', height: '100%' }} /> : icon}
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        gap: 1,
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        alignSelf: 'stretch',
                        mt: 1.5,
                    }}
                >
                    <Typography
                        variant="subtitle1"
                        sx={{
                            overflow: 'hidden',
                            color: 'text.primary',
                            textAlign: 'center',
                            textOverflow: 'ellipsis',
                            fontWeight: 700,
                        }}
                    >
                        {title}
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            alignSelf: 'stretch',
                            color: 'text.secondary',
                            textAlign: 'center',
                            fontWeight: 500,
                            lineHeight: 1.4,
                        }}
                    >
                        {description}
                    </Typography>
                </Box>
            </Box>
        </NavLink>
    );
};

export default memo(CategoryCard);
